import { render } from "./CreateGroupsModal.vue?vue&type=template&id=d024c9ca&scoped=true"
import script from "./CreateGroupsModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupsModal.vue?vue&type=script&lang=js"

import "./CreateGroupsModal.vue?vue&type=style&index=0&id=d024c9ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d024c9ca"]])

export default __exports__